import React from "react";
import * as Icons from "lucide-react";

// Shared icon feature card used by Consulting + Managed Services grids
export const IconFeatureCard = ({ icon, title, body }) => {
  const Icon = Icons[icon] || Icons.Circle;
  return (
    <div className="group rounded-2xl bg-white p-7 border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
      <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
        <Icon className="h-6 w-6" />
      </span>
      <h3 className="mt-5 font-display text-base font-bold text-slate-900">{title}</h3>
      <p className="mt-2 text-sm text-slate-500 leading-relaxed">{body}</p>
    </div>
  );
};

export const SectionIntro = ({ eyebrow, title }) => (
  <div className="max-w-2xl mx-auto text-center mb-14">
    <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">{eyebrow}</span>
    <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 text-balance">{title}</h2>
  </div>
);
